import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import * as apiService from "../service/ApiService";

const FettiCompanyLogo = ({ jobId }) => {
  const dispatch = useDispatch();
  const serverCompanyData = useSelector(
    (state) => state.apply.serverCompanyData
  );
  const logoUrl = serverCompanyData[jobId]?.logoUrl;
  useEffect(() => {
    if (logoUrl) return;
    if (!jobId) return;
    apiService.getCompanyInfoByJobId(dispatch, null, { jobId }, {});
  }, [jobId, logoUrl]);

  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt="Company Logo"
        style={{
          // width: "48px",
          height: "48px",
          width: "auto",
          maxWidth: "500px",
        }}
      />
    );
  }
  return null;
};

export default FettiCompanyLogo;
